module.exports = __webpack_public_path__ + "img/63f2d4e.png";